import React from 'react';
import './catalog-screen.scss';
import {
  CatalogHeader,
  CatalogList,
  NestedCategories,
} from '@zonofi/zono-money-whatsapp-stack';
import { useCatalogScreen } from './hooks/useCatalogScreen';
import { LoadingSpinner, SVGS } from '@zonofi/zono-money-design-system';
import { useLocation } from 'react-router-dom';
import { isUndefined } from 'lodash';
import { FallBackScreen } from '@zonofi/zono-money-whatsapp-stack';
import {
  dispatch,
  getIsSimulation,
  updateCurrentTooltipIndex,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { sendWAEventToParent } from '@zonofi/zono-money-helpers';

export const CatalogScreen: React.FC = () => {
  const location = useLocation();
  const isSimulation = useAppSelector(getIsSimulation);

  const isCatalogue = location?.pathname?.includes('catalogue');
  const isPriceList = location?.pathname?.includes('pricelist');
  const isCampaign = location?.pathname?.includes('campaign');
  const {
    showSearch,
    setShowSearch,
    searchKey,
    setSearchKey,
    getName,
    categories,
    setSelectedCategories,
    productsList,
    onScroll,
    pageNo,
    error,
    lastItemRef,
    getCampaignDetailsResponse,
    listProductsAPIResponse,
    isCatalogueLoading,
    orderSummary,
    onSuccess,
    onIncrement,
    onDecrement,
    onAddToCart,
    onDelete,
    onOpenMediaSearch,
    fromSource,
    backToCart,
    onChangeQuantity,
    showImage,
    showPrice,
    cartAPIResponse,
    listView,
    isEmpty,
    toggleCatalogView,
    isCatalogueViewToggleDisabled,
    catalogueView,
    showOutOfStack,
    isOrderTaskEnabled,
  } = useCatalogScreen();

  return (
    <div className="catalog-screen-v2">
      <div className="catalog-screen-v2-header-category-container">
        <CatalogHeader
          showSearch={showSearch}
          setShowSearch={setShowSearch}
          searchKey={searchKey}
          setSearchKey={setSearchKey}
          getName={getName}
          isCatalogue={isCatalogue}
          isCampaign={isCampaign}
          isPriceList={isPriceList}
          getCampaignDetailsResponse={getCampaignDetailsResponse}
          onSuccess={onSuccess}
          onOpenMediaSearch={onOpenMediaSearch}
          fromSource={fromSource}
          backToCart={backToCart}
          cartQuantity={orderSummary.skuCount}
          handleView={toggleCatalogView}
          listView={listView}
          isCatalogueViewToggleDisabled={isCatalogueViewToggleDisabled}
          showCartButton={isOrderTaskEnabled}
          // headerRef={headerRef}
          showCategory={true}
        />
        {categories && searchKey?.length <= 0 && (
          <NestedCategories
            categories={categories}
            updateSelectedCategories={setSelectedCategories}
          />
        )}
      </div>
      {error?.show && (
        <div className="catalog-screen-v2-error-section font-primary">
          <h2 className=" font-primary">{error?.code}</h2>
          <span className="font-primary-semibold">{error?.message}</span>
        </div>
      )}
      {isCatalogueLoading ? (
        <div className="catalog-screen-v2-loading">
          <LoadingSpinner />
        </div>
      ) : isEmpty ? (
        <FallBackScreen
          image={SVGS.EmptySearch}
          message="Oops! No products found."
          description=""
          {...(isSimulation
            ? {
                buttonName: 'Back to Whatsapp Simulator',
                onButtonClick: () =>
                  sendWAEventToParent({ noProductsFound: true }),
              }
            : {})}
          contentStyle={{
            justifyContent: 'flex-start',
          }}
        />
      ) : productsList?.length > 0 ? (
        <>
          <div
            className={`catalog-list${listView ? '-grid' : ''}`}
            onTouchMove={onScroll}
          >
            <CatalogList
              catalogueView={catalogueView}
              products={productsList}
              onIncrement={onIncrement}
              onDecrement={onDecrement}
              onAddToCart={onAddToCart}
              onDelete={onDelete}
              onChangeQuantity={onChangeQuantity}
              showImage={showImage}
              showPrice={showPrice}
              listView={listView}
              showOutOfStack={showOutOfStack}
              showActionButtons={isOrderTaskEnabled}
            />
            <div ref={lastItemRef} className="lastItemRef" />
          </div>
          {listProductsAPIResponse?.isLoading && pageNo !== 1 && (
            <div className="catalog-screen-v2-list-loading font-primary">
              <LoadingSpinner size={'small'} />
            </div>
          )}
        </>
      ) : (
        !error?.show && (
          <div className="catalog-screen-v2-loading">
            <LoadingSpinner />
          </div>
        )
      )}
      {/* main section end  */}
      {/* footer section start */}
      {!cartAPIResponse?.isLoading &&
        cartAPIResponse?.isSuccess &&
        !isCatalogueLoading &&
        !isUndefined(orderSummary?.skuCount) &&
        orderSummary?.skuCount !== 0 &&
        isOrderTaskEnabled &&
        !fromSource &&
        searchKey?.length === 0 && (
          <div className="catalog-screen-v2-footer-container font-primary-semibold">
            <div className="catalog-screen-v2-footer-popup">
              <div className="catalog-screen-v2-footer-popup-left">
                <span>{`${orderSummary?.skuCount} Items • ${orderSummary?.totalQuantity} Qty`}</span>
              </div>
              <div
                className="catalog-screen-v2-footer-popup-right"
                onClick={() => {
                  onSuccess();
                  if (isSimulation) {
                    dispatch(updateCurrentTooltipIndex(2));
                  }
                }}
              >
                <span>Go To Cart</span>
                <img
                  src={SVGS.LeftArrowWhite}
                  className="catalog-screen-v2-footer-popup-right-arrow"
                  alt="go-to-cart-arrow"
                />
              </div>
            </div>
          </div>
        )}
    </div>
  );
};
